import './App.css';
import React, { Suspense, lazy, useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import CompLoaderDt from './Components/Common/CompLoaderDt';

// Tenant context
import { TenantContext } from './TenantContext';

const Home = lazy(() => import('./Pages/Home'));
const CategoryProductListPage = lazy(() => import('./Pages/Category/CategoryProductListPage'));
const ProductDetails = lazy(() => import('./Pages/Product/Details'));
const LoginPage = lazy(() => import('./Pages/Member/LoginPage'));
const RegisterPage = lazy(() => import('./Pages/Member/RegisterPage'));
const ActivationCodeRequest = lazy(() => import('./Pages/Member/ActivationCodeRequest'));
const Activation = lazy(() => import('./Pages/Member/Activation'));
const ResetPassword1 = lazy(() => import('./Pages/Member/ResetPassword1'));
const ResetPassword2 = lazy(() => import('./Pages/Member/ResetPassword2'));
const Logout = lazy(() => import('./Pages/Member/Logout'));
const MyAccount = lazy(() => import('./Pages/Member/MyAccount'));
const MyMpCbiProcessList = lazy(() => import('./Pages/Member/MyMpCbiProcessList'));
const MyMpTicProcessList = lazy(() => import('./Pages/Member/MyMpTicProcessList'));
const CreateCbiProcessApplication = lazy(() => import('./Pages/Member/Process/CBI/CreateCbiProcessApplication'));
const CreateTicProcessApplication = lazy(() => import('./Pages/Member/Process/TIC/CreateTicProcessApplication'));
const Basket = lazy(() => import('./Pages/Basket'));
const Other = lazy(() => import('./Pages/Other'));
const AboutUs = lazy(() => import('./Pages/AboutUs'));
const Contact = lazy(() => import('./Pages/Contact'));
const ProtectionOfPersonalData = lazy(() => import('./Pages/ProtectionOfPersonalData'));
const FrequentlyAskedQuestions = lazy(() => import('./Pages/FrequentlyAskedQuestions'));
const DeliveryAndReturns = lazy(() => import('./Pages/DeliveryAndReturns'));
const BeingASeller = lazy(() => import('./Pages/BeingASeller'));
const ChangedLanguage = lazy(() => import('./Pages/ChangedLanguage'));
const Session = lazy(() => import('./Components/Session'));
const Callback = lazy(() => import('./Pages/Checkout/Callback'));

const publicRoutes = [
  { path: "/", component: Home },
  { path: "/changed-language", component: ChangedLanguage },
  { path: "/login", component: LoginPage },
  { path: "/register", component: RegisterPage },
  { path: "/activation-code-request", component: ActivationCodeRequest },
  { path: "/activation", component: Activation },
  { path: "/reset-password-1", component: ResetPassword1 },
  { path: "/reset-password-2", component: ResetPassword2 },
  { path: "/logout", component: Logout },
  { path: "/other", component: Other },
  { path: "/about-us", component: AboutUs },
  { path: "/contact", component: Contact },
  { path: "/frequently-asked-questions", component: FrequentlyAskedQuestions },
  { path: "/being-a-seller", component: BeingASeller },
  { path: "/protection-of-personal-data", component: ProtectionOfPersonalData },
  { path: "/category/:categoryUrl/products", component: CategoryProductListPage },
  { path: "/product/:id/details", component: ProductDetails },
  { path: "/protection-of-personal-data", component: ProtectionOfPersonalData },
  { path: "/delivery-and-returns", component: DeliveryAndReturns },
  { path: "/checkout/callback/:id?", component: Callback },
];

const authProtectedRoutes = [
  { path: "/my-account/:id?", component: MyAccount },
  { path: "/basket", component: Basket },
  { path: "/my-cbi-process-list", component: MyMpCbiProcessList },
  { path: "/my-tic-process-list", component: MyMpTicProcessList },
  { path: "/create-cbi-process/:taskId/application", component: CreateCbiProcessApplication, template: "CreateCbiProcessApplication" },
  { path: "/create-cbi-process/:taskId/application-return", component: CreateCbiProcessApplication, template: "CreateCbiProcessApplicationReturn" },
  { path: "/create-cbi-process/:taskId/application-approval", component: CreateCbiProcessApplication, template: "CreateCbiProcessApplicationApproval" },
  { path: "/create-tic-process/:taskId/application", component: CreateTicProcessApplication, template: "CreateTicProcessApplication" },
  { path: "/create-tic-process/:taskId/application-return", component: CreateTicProcessApplication, template: "CreateTicProcessApplicationReturn" },
  { path: "/create-tic-process/:taskId/application-support-desk", component: CreateTicProcessApplication, template: "CreateTicProcessApplicationSupportDesk" },
];

function App() {
  const [tenantConfig, setTenantConfig] = useState(null);

  useEffect(() => {
    fetch('/config.json')
      .then(res => res.json())
      .then(cfg => setTenantConfig(cfg))
      .catch(() => setTenantConfig({})); // fallback boş config
  }, []);

  if (!tenantConfig) {
    return <div className="text-center mt-5"><CompLoaderDt /></div>;
  }

  return (
    <TenantContext.Provider value={tenantConfig}>
      <div className="App">
        <React.Fragment>
          <Suspense fallback={<div className="text-center mt-5"><CompLoaderDt /></div>}>
            <Routes>
              {publicRoutes.map((route, idx) => (
                route.template !== "" ?
                  <Route
                    path={route.path}
                    element={<><route.component template={route.template} /></>}
                    key={idx}
                    exact={true}
                  /> : <Route
                    path={route.path}
                    element={<><route.component /></>}
                    key={idx}
                    exact={true}
                  />
              ))}
              {authProtectedRoutes.map((route, idx) => (
                route.template !== "" ?
                  <Route
                    path={route.path}
                    element={<><Session><route.component template={route.template} /></Session></>}
                    key={idx}
                    exact={true}
                  /> : <Route
                    path={route.path}
                    element={<><Session><route.component /></Session></>}
                    key={idx}
                    exact={true}
                  />
              ))}
            </Routes>
          </Suspense>
        </React.Fragment>
      </div>
    </TenantContext.Provider>
  );
}

export default App;
